import React from 'react';
import { Link } from 'shared';
import { Theme } from 'theme';

import { HeaderNavWrapper } from './HeaderNav.styles';
import { HeaderNavProps } from './HeaderNav.types';
import { HeaderSubNav } from './headerSubNav/HeaderSubNav';

export const HeaderNav = ({ active, links, onClickLink, onOpenSubMenu, subMenuOpened }: HeaderNavProps) => {
  const handleOpenSubMenu = (index: number) => (event: React.MouseEvent) => {
    event.preventDefault();
    onOpenSubMenu(index);
  };

  const handleDesktopSubMenu = (index: number | null) => {
    if (window.innerWidth >= Theme.variables.breakpoints.lg) {
      onOpenSubMenu(index);
    }
  };

  const handleClickLink = () => {
    onOpenSubMenu(null);
    onClickLink();
  };

  const handleClickBackToTopMenu = () => {
    onOpenSubMenu(null);
  };

  return (
    <HeaderNavWrapper className="header__nav">
      <ul className="header__nav-list">
        {links.map((link, index) => (
          <li
            className="header__nav-item"
            key={index}
            onMouseEnter={() => handleDesktopSubMenu(index)}
            onMouseLeave={() => handleDesktopSubMenu(null)}
            onFocus={() => handleDesktopSubMenu(index)}
            onBlur={event => {
              if (!event.currentTarget.contains(event.relatedTarget)) {
                handleDesktopSubMenu(null);
              }
            }}
          >
            <Link
              className={`header__nav-link ${active === link.url ? 'header__nav-link--active' : ''} ${
                link.subLinks && link.subLinks.length ? 'header__nav-link--parent' : ''
              }`}
              onClick={link.subLinks && link.subLinks.length > 0 ? handleOpenSubMenu(index) : handleClickLink}
              {...link}
            />

            {link.subLinks && link.subLinks.length > 0 && (
              <HeaderSubNav
                active={active}
                links={link.subLinks}
                isOpen={subMenuOpened === index}
                onClickLink={handleClickLink}
                onClickBack={handleClickBackToTopMenu}
              />
            )}
          </li>
        ))}
      </ul>
    </HeaderNavWrapper>
  );
};
